import { useCallback, useEffect, useState } from 'react';

import { api } from '../api.ts';
import { useModosithat } from '../felhasznalo-context.ts';
import { Mezo } from '../reszek/Mezo.tsx';

/**
 * Cégadatok. (3.0 / 3.)
 *
 * Ezek kerülnek az okmányokra, a szerződésekre és a levelekre. Semmi nincs
 * a programba égetve: ha egy engedély megújul, itt átírjátok, és a
 * következő okmányra már az új kerül — a korábban kiállítottakon a
 * kiállításkori adat marad.
 */

interface CegadatMezo {
  kulcs: string;
  cimke: string;
  ertek: string;
}

interface CegadatCsoport {
  kulcs: string;
  cimke: string;
  mezok: CegadatMezo[];
}

export function Cegadatok() {
  const [csoportok, setCsoportok] = useState<CegadatCsoport[]>([]);
  const [hiba, setHiba] = useState<string | null>(null);
  const modosithat = useModosithat('cegadat');

  const betolt = useCallback(async () => {
    try {
      const v = await api.get<{ csoportok: CegadatCsoport[] }>('/api/cegadat');
      setCsoportok(v.csoportok);
      setHiba(null);
    } catch (h) {
      setHiba(h instanceof Error ? h.message : 'A cégadatokat nem sikerült betölteni.');
    }
  }, []);

  useEffect(() => {
    void betolt();
  }, [betolt]);

  async function ment(kulcs: string, ertek: string | null) {
    try {
      const v = await api.patch<{ csoportok: CegadatCsoport[] }>(`/api/cegadat/${kulcs}`, { ertek });
      setCsoportok(v.csoportok);
      setHiba(null);
    } catch (h) {
      setHiba(h instanceof Error ? h.message : 'A mentés nem sikerült.');
    }
  }

  return (
    <>
      <div className="dayhead">
        <span style={{ fontSize: 15, fontWeight: 600 }}>Cégadatok</span>
        <span className="hint">Ezek kerülnek az okmányokra, a szerződésekre és a levelekre.</span>
      </div>

      {hiba && <div className="uzenet bad">{hiba}</div>}

      {csoportok.map((cs) => (
        <div className="panel" key={cs.kulcs} style={{ marginTop: 16, maxWidth: 760 }}>
          <p className="lbl">{cs.cimke}</p>
          {cs.mezok.map((m) => (
            <div className="cegsor" key={m.kulcs}>
              <label>{m.cimke}</label>
              <Mezo ertek={m.ertek} tiltva={!modosithat} onMent={async (uj) => ment(m.kulcs, uj)} />
            </div>
          ))}
        </div>
      ))}

      <div className="hint" style={{ marginTop: 14, maxWidth: 760 }}>
        Az engedélyszámok időnként megújulnak. Ha itt átírod, a következő okmányokra már az új
        kerül — a korábban kiállítottakon a kiállításkori adat marad.
      </div>
    </>
  );
}
